import { useEffect, useState } from 'react';

export function useScrollPositionInternal() {
  const [hasPageLoaded, setHasPageLoaded] = useState(false);
  const [isAtPageTop, setIsAtScrollTop] = useState<boolean | undefined>();

  useEffect(() => {
    function onScroll() {
      setIsAtScrollTop(window.scrollY <= 0);
    }
    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return {
    hasPageLoaded,
    setHasPageLoaded,
    isAtPageTop,
  };
}
